import { createContext } from "react";

export const EnquiryPropertiesContext = createContext((enquiryId: number) => {});
